<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :kDateCodeGeq="search.dateCodeGeq"
      :kDateCodeLeq="search.dateCodeLeq"
      :kpiStatus="kpiStatusNow"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :kDateCodeGeq="search.dateCodeGeq"
        :kDateCodeLeq="search.dateCodeLeq"
        :checkArr="checkArr"
        @clearKey="clearKey"
        @exportReport="exportReport"
      />
      <router-view
        :check_arr="checkArr"
        :items="items"
        :first_loading="firstLoading"
        @openDetail="openDetail"
      ></router-view>
      <pagination
        v-if="!firstLoading"
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/supplier-kpi-batch/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
      <modalDetail :open="detail.open" :item="detail.params"></modalDetail>
    </div>
  </div>
</template>

<script>
import LeftSide from "./left-side";
import Header from "./header";
import { pagination } from "@components/pagination";
import modalDetail from "./modal-detail";

export default {
  components: {
    LeftSide,
    Header,
    pagination,
    modalDetail,
  },
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      loading: true,
      firstLoading: true,
      page: this.$route.params.page ? this.$route.params.page : 1,
      pageSizeSelect: [10, 20, 50],
      rowsPerPage: parseInt(store.get("supplier-kpi-batch-rowsPerPage"))
        ? parseInt(store.get("supplier-kpi-batch-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      items: [],
      search: {
        dateCodeGeq: "",
        dateCodeLeq: "",
      },
      kpiStatusNow: '',
      checkArr: [],
      detail: {
        open: Symbol(),
        params: {},
      },
      detailDefault: "{}",
    };
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("supplier-kpi-batch-rowsPerPage", this.rowsPerPage);
    },
  },
  mounted() {
    this.totalPage = 0;
    this.detailDefault = JSON.stringify(this.detail);
    this.getItems();
  },
  methods: {
    getItems(s) {
      this.loading = true;
      $.api_call(
        "api.SupplierKpi.findBySupplier",
        {
          page: this.page,
          rowsPerPage: this.rowsPerPage,
          status: this.kpiStatusNow,
          sendDateGeq: this.search.dateCodeGeq
            ? moment(this.search.dateCodeGeq).format("YYYY-MM-DD")
            : "",
          sendDateLeq: this.search.dateCodeLeq
            ? moment(this.search.dateCodeLeq).format("YYYY-MM-DD")
            : "",
        },
        (r) => {
          this.loading = false;
          this.firstLoading = false;
          if (r.ErrorCode == "9999") {
            this.items = r.Data.Results;
            this.totalPage = r.Data.Pagination.totalPage;
            this.totalCount = r.Data.Pagination.totalCount;
            if (!s) $("html,body").scrollTop(0);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    filtrate(id, name, dateCodeGeq, dateCodeLeq, kpiStatusNow) {
      this.search.supplierId = id;
      this.search.supplierName = name;
      this.search.dateCodeGeq = dateCodeGeq;
      this.search.dateCodeLeq = dateCodeLeq;
      this.kpiStatusNow = kpiStatusNow;
      this.toPage(1);
    },
    clearKey(type) {
      switch (type) {
        case "date":
          this.search.dateCodeGeq = this.search.dateCodeLeq = "";
          break;
      }
      this.toPage(1);
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({ path: "/supplier-kpi-batch/" + num });
      if (page == num) {
        this.getItems();
      }
      this.checkArr = [];
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getItems();
      this.checkArr = [];
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ path: "/supplier-kpi-batch/" + 1 });
      if (page == 1) {
        this.getItems();
      }
      this.checkArr = [];
    },
    exportReport() {
      if (this.checkArr.length == 0) return;
      if ($("#ifile").length == 0) {
        $("body").append('<iframe id="ifile" style="display:none"></iframe>');
      }
      this.loading = true;
      $.api_call(
        "api.SupplierKpi.exportKpi",
        {
          idList: this.checkArr,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            document.getElementById("ifile").src = r.Data.Results.url;
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    openDetail(item) {
      this.detail = JSON.parse(this.detailDefault);
      this.detail.open = Symbol();
      this.detail.params = item;
      $("#modalSupplierKpiDetail").modal("show");
    },
  },
};
</script>
